import { useQuery } from 'react-query';

import Api from '../../api/api';

export const getReportedCommentByPostId = async (commentId: string) => {
  const [response, bodyOrError] = await Api.get(`comments/${commentId}/reported`);

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useGetReportedCommentByPostId = (commentId: string) =>
  useQuery(['getReportedCommentById', commentId], () => getReportedCommentByPostId(commentId), {
    enabled: commentId !== 'new' || !!commentId,
  });
